module.exports = __webpack_public_path__ + "static/Meen@2x.1c84b9d8.png";